import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=0d714736&scoped=true&"
import script from "./VCheckbox.vue?vue&type=script&lang=js&"
export * from "./VCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=0d714736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d714736",
  null
  
)

export default component.exports